module.exports = __webpack_public_path__ + "img/like.a8fc16ac.svg";